import WhattsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab, Tooltip } from '@mui/material';
import i18n from '../../libs/language';

const WHATSAPP_NUMBER = '5491125928670';

export const WhattsAppButton = () => {
  const handleClick = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title={i18n.t('app.whattsapp_icon')}>
      <Fab
        color="success"
        onClick={handleClick}
        sx={{
          width: 64,
          height: 64,
          position: 'fixed',
          bottom: 44,
          right: 24,
          zIndex: 9999,
        }}
      >
        <WhattsAppIcon sx={{ fontSize: 36 }} />
      </Fab>
    </Tooltip>
  );
};
